import { render } from "./DisabilityParkingPage.vue?vue&type=template&id=521762d8&scoped=true"
import script from "./DisabilityParkingPage.vue?vue&type=script&lang=js"
export * from "./DisabilityParkingPage.vue?vue&type=script&lang=js"

import "./DisabilityParkingPage.vue?vue&type=style&index=0&id=521762d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521762d8"]])

export default __exports__